// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCloudSyncOutlinedSvg from "@fishx/icons-svg/es/asn/PCloudSyncOutlined";
import FishxIcon from '../components/FishxIcon';

var PCloudSyncOutlined = function PCloudSyncOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCloudSyncOutlinedSvg
  }));
};

PCloudSyncOutlined.displayName = 'PCloudSyncOutlined';
export default React.forwardRef(PCloudSyncOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCloudSyncOutlined.js
// module id = 3293
// module chunks = 0